import { GlBadge, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'HiddenBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    }
};
